import styled from "styled-components";
import { colors } from "../../../utils";

const Wrapper
	= styled.div`
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: calc(2px + .2vw);
		min-height: 20vh;
		font-size: 120%;
		color: ${colors.info};

		svg {
			font-size: 150%;
		}
		
	`

export default Wrapper
